module.exports = __webpack_public_path__ + "static/media/student-summary-top.56070b6e.png";